import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowLeftRightIcon, MoreHorizontalIcon, PencilLineIcon, ShieldAlertIcon, TimerIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
const itemCls = 'flex h-11 w-full items-center gap-3 px-4 text-left text-sm font-semibold transition-colors duration-150 hover:bg-canvas';

/** Redkeje uporabljena dejanja zaslona Danes. */
export function TodayMenu() {
  const {
    viewer,
    isAdmin,
    timer
  } = useAppState();
  const {
    setTimerSheetOpen,
    openException,
    setTab,
    openManualEntry
  } = useUi();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  const go = (fn: () => void) => {
    setOpen(false);
    fn();
  };
  return <div ref={ref} className="relative" data-id="element-1221" data-mp="3r217tq7mi593">
      <button type="button" onClick={() => setOpen(o => !o)} aria-haspopup="menu" aria-expanded={open} aria-label="Več dejanj" className="grid h-11 w-11 place-items-center rounded-2xl border-[1.5px] border-line bg-surface text-ink shadow-pressSoft transition-colors duration-150 hover:bg-canvas focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent" data-id="element-1222" data-mp="3d4cnqkldr253">
        <MoreHorizontalIcon className="h-5 w-5" aria-hidden="true" data-id="element-1223" data-mp="11flakj7n7brt" />
      </button>
      <AnimatePresence data-id="element-1224" data-mp="16dwmr0letyd7">
        {open && <motion.div role="menu" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute right-0 top-full z-30 mt-2 w-64 origin-top-right overflow-hidden rounded-2xl border border-line bg-surface py-1 shadow-bar" data-id="element-1225" data-mp="16bk7wway844d">
            <button role="menuitem" type="button" className={itemCls} onClick={() => go(() => setTimerSheetOpen(true))} data-id="element-1226" data-mp="1nmpgk3xa1yz8">
              <TimerIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-1227" data-mp="1inm8sbpwxenk" /> {timer ? 'Odpri časovnik' : 'Prosti časovnik'}
            </button>
            <button role="menuitem" type="button" className={itemCls} onClick={() => go(() => openManualEntry())} data-id="element-1228" data-mp="1dvcl72c9sqog">
              <PencilLineIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-1229" data-mp="18w8ecictj51a" /> Vpiši čas ročno
            </button>
            <button role="menuitem" type="button" className={itemCls} onClick={() => go(() => setTab('druzina'))} data-id="element-1230" data-mp="21n0715uodbjv">
              <ArrowLeftRightIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-1231" data-mp="29w5ynl5zo2bs" /> Na voljo za prevzem
            </button>
            {!isAdmin && <button role="menuitem" type="button" className={itemCls} onClick={() => go(() => openException(viewer.id))} data-id="element-1232" data-mp="2dz2ckykl3a9e">
                <ShieldAlertIcon className="h-4 w-4 text-muted" aria-hidden="true" data-id="element-1233" data-mp="2nuvxb58gia29" /> Predlagaj izjemo
              </button>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}